export const BASIC_INFO_STEP_ID = 'confirm_details';

export function hasCompletedStepAfterBasicInfo(
  sections: ReadonlyArray<{ id: string; requirementsMet?: boolean }>
): boolean {
  const basicInfoIndex = sections.findIndex(
    (section) => section.id === BASIC_INFO_STEP_ID
  );
  if (basicInfoIndex === -1) return false;
  return sections
    .slice(basicInfoIndex + 1)
    .some((section) => section.requirementsMet === true);
}

export function shouldHideBasicInfoProgressBar(
  isSimpleSizingStep: boolean,
  sections: ReadonlyArray<{ id: string; requirementsMet?: boolean }>
): boolean {
  return isSimpleSizingStep && !hasCompletedStepAfterBasicInfo(sections);
}
